import { render, staticRenderFns } from "./App.vue?vue&type=template&id=75724d15&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=75724d15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75724d15",
  null
  
)

export default component.exports